// src/components/Home.tsx
import React, {FC} from 'react';
import { useState, useRef, useEffect } from "react";
import { DefaultProvider, sha256, toHex, PubKey, bsv, TestWallet, Tx, toByteString } from "scrypt-ts";
import './App.css';
import { pvtkey } from './globals';

import { broadcast, listUnspent } from './mProviders';


export let homepvtKey: string = "";
export let homenetwork = bsv.Networks.testnet;
export let compState = true;



//const provider = new DefaultProvider({network: homenetwork});
let signer: TestWallet;

const Home01pw2pvtkey: FC = () => {

  const [hexpvtkey, sethexpvtkey] = useState("");
  const [pvtkeyAlert, setpvtkeyAlert] = useState("");
  const [pvtkeyAlert02, setpvtkeyAlert02] = useState("");
  const [pvtkeyAlert03, setpvtkeyAlert03] = useState("");


  let localPvtKey = useRef<any>(null);


  const insertPVT = async (amount: any) => {

    //Criação da CHAVE PRIVADA através do Password
    if( localPvtKey.current.value.length >= 8)
    {
      console.log('PassW: ', localPvtKey.current.value)
      console.log('PassW Hex: ', Buffer.from(localPvtKey.current.value, 'utf-8').toString('hex'))
      let base = Buffer.from(localPvtKey.current.value, 'utf-8').toString('hex')
      let a = sha256(base).toString()
      for(let i = 0; i < base.length; i ++ )
      {
        a = a + base.charAt(i) + base.charAt(i)
        //console.log('a: ', a)
        a = sha256(a).toString()
      }
      //a = sha256(a)
      //homepvtKey = a
      console.log('PVT Key: ',a)

      sethexpvtkey(a)
      setpvtkeyAlert('You may forget the passoword.')
      setpvtkeyAlert02('But keep safe the private key safe and PRIVATE.')
      setpvtkeyAlert03('If you lose the Private Key, it can not be recovered!!!')
      //setpvtkeyAlert04('If you lose the Private Key, it can not be recovered!!!')
    }
    else
    {
      alert("PassWord too short");
      sethexpvtkey('')
      setpvtkeyAlert('')
      setpvtkeyAlert02('')
      setpvtkeyAlert03('')
    }

  };

  return (

    <div className="App-header">
      <h2 style={{ fontSize: '34px', paddingBottom: '5px', paddingTop: '5px'}}>

        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        
        New Hex Private Key
        
      </h2>


      <div>

          <div style={{ textAlign: 'center', paddingBottom: '20px' }}>
                
                <label style={{ fontSize: '14px', paddingBottom: '2px' }}
                  >Insert a Pasword at least 8 char long:  
                </label>     
          </div>

          <div style={{ display: 'inline-block', textAlign: 'center', paddingBottom: '20px' }}>
            <label style={{ fontSize: '14px', paddingBottom: '5px' }}  
                > 
                  {/* <input ref={localPvtKey} type="hex" name="PVTKEY1" min="1" defaultValue={'PVT KEY'} placeholder="hex" />*/}
                  <input ref={localPvtKey} type="password" name="PVTKEY1" min="1" placeholder="PassWord (8 char min)" />
                </label>     
            </div>
            <div style={{ display: 'inline-block', textAlign: 'center' }}>
                
                <button className="insert" onClick={insertPVT}
                    style={{ fontSize: '14px', paddingBottom: '2px', marginLeft: '20px'}}
                >Create</button>

            </div>
        </div>

        <div className="label-container" style={{ textAlign: 'center' }}>
                            <label className="responsive-label" htmlFor="output1"  style={{ fontSize: '12px', paddingBottom: '20px' }}                           
                            >
                                {'Hex Pvt Key: ' + hexpvtkey} 
                            </label>
                            <output id="output1"></output>

                          {/*
                            <label className="responsive-label" ref={labelRef} style={{ fontSize: '12px', paddingBottom: '5px' }} 
                            >
                              {pubkey}

                            </label>       */}            
        </div>

        {
          pvtkeyAlert !== ''?

          <div>
              <div style={{ textAlign: 'center', paddingBottom: '20px', paddingTop: '0px' }}>
                  <label htmlFor="output1"  style={{ fontSize: '12px', paddingBottom: '5px' }}                           
                  >
                      {pvtkeyAlert} 
                  </label>
                  <output id="output1"></output>
              </div>
              <div style={{ textAlign: 'center', paddingBottom: '20px' }}>
                          <label htmlFor="output1"  style={{ fontSize: '12px', paddingBottom: '5px' }}                           
                          >
                              {pvtkeyAlert02} 
                          </label>
                          <output id="output1"></output>             
              </div>
              <div style={{ textAlign: 'center', paddingBottom: '20px' }}>
                          <label htmlFor="output1"  style={{ fontSize: '12px', paddingBottom: '5px' }}                           
                          >
                              {pvtkeyAlert03} 
                          </label>
                          <output id="output1"></output>             
              </div>
          </div>
          :
          ''
        }

        <a href='https://medium.com/@cktcracker/new-private-key-95f5b98a8aa0' target="_blank" rel="noopener noreferrer"
        style={{ fontSize: '14px', paddingBottom: '5px', color: 'yellow' }}>
            Instructions of Use
        </a>

    </div>
  );
};

export default Home01pw2pvtkey;